<div class="documents-container">
  <!-- Documents Content -->
  <div class="documents-content">
    <app-document-upload
      [documents]="documents"
      [folderLevels]="folderLevels"
      [loading]="loading"
      [error]="error"
      [showDocumentList]="true"
      [validationConfig]="documentUploadValidationConfig"
      [disabled]="disabled"
      [entityId]="entityId"
      [entityType]="'lead'"
      [currentFolderId]="folderHierarchyId"
      [baseFolderId]="getBaseFolderId()"
      [activeFolderNodeId]="getActiveFolderNodeId()"
      [hideFilters]="true"
      [searchTerm]="searchTerm"
      buttonText="Upload File"
      buttonVariant="primary"
      buttonSize="medium"
      (uploadComplete)="onDocumentUploadComplete($event)"
      (filesSelected)="onDocumentsSelected($event)"
      (uploadCancelled)="cancelUpload($event)"
      (documentDeleted)="deleteItem($event)"
      (documentDownloaded)="downloadDocument($event)"
      (documentPreviewed)="onDocumentPreview($event)"
      (retryLoad)="loadDocuments()"
      (folderCreateRequest)="onFolderCreateRequest($event)"
      (folderCreated)="onFolderCreated($event)"
      (folderCreationError)="onFolderCreationError($event)"
      (folderCreationErrorClear)="onFolderCreationClearError()"
      [folderCreationSuccess]="folderCreationSuccess"
      [folderCreationApiError]="folderCreationError"
      (folderRenameRequest)="onFolderRenameRequest($event)"
      (folderRenameErrorClear)="onRenameFolderClearError()"
      [folderRenameSuccess]="folderRenameSuccess"
      [folderRenameError]="folderRenameError"
      (folderClicked)="onFolderClick($event)"
      (backClicked)="onBackClick()"
      (viewModeChange)="onViewModeChange($event)"
      (itemMoved)="onItemMoved($event)"
      (moveRequest)="onMoveRequest($event)">
    </app-document-upload>
  </div>

  <!-- File Preview Modal -->
  <app-file-preview-modal
    [isOpen]="showPreviewModal"
    [document]="previewDocument"
    [entityType]="'lead'"
    [entityId]="entityId || undefined"
    (isOpenChange)="onPreviewClose($event)"
    (downloadRequested)="onPreviewDownload($event)">
  </app-file-preview-modal>
</div>
